var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPathOption2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 49.885 50.974",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-72.802 -1.8972)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.005,
    cy: 47.054,
    rx: 3.7783,
    ry: 3.7892
  }), /*#__PURE__*/React.createElement("path", {
    d: "m75.305 37.14c-.05405-4.5208.64152-10.994 4.833-12.67 5.9109-2.3623 21.705-.27224 17.219 8.2609-2.2698 4.3176-6.1819 10.038-3.6147 14.185 3.2143 5.1922 14.351 3.9621 19.051.06795 7.3924-6.1258 10.101-20.354 4.1181-27.867-9.1026-11.43-19.877-11.258-19.877-11.258",
    fill: "none",
    stopColor: "#000000",
    strokeDasharray: "20, 10",
    strokeDashoffset: 39,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    transform: "matrix(1.0795 0 0 1.0826 36.191 3.256)",
    d: "m38.978 1.0574 7.0745 8.2831m1.1169-7.1777-9.017 6.1117",
    stopColor: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.625
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathOption2);
export default __webpack_public_path__ + "static/media/path-option-2.e49632c3df63843b25a83f174f304d1b.svg";
export { ForwardRef as ReactComponent };